import { alpha } from '@mui/material/styles';
import { Box, Stack } from '@mui/system';
const shimmer = {
  animation: 'shimmer 1.6s ease-in-out infinite',
  '@keyframes shimmer': {
    '0%': { opacity: 0.55 },
    '50%': { opacity: 0.85 },
    '100%': { opacity: 0.55 },
  },
};

export function CardsSkeleton({ count = 5 }) {
  return (
    <Stack spacing={2}>
      {Array.from({ length: count }).map((_, i) => (
        <Box
          key={i}
          sx={(theme) => ({
            border: `1px solid ${alpha(theme.palette.divider, 0.9)}`,
            borderRadius: 3,
            bgcolor: theme.palette.background.paper,
          })}
        >
          <Box sx={{ p: 2.5 }}>
            <Box
              sx={(theme) => ({
                ...shimmer,
                height: 18,
                width: '50%',
                borderRadius: 999,
                bgcolor: alpha(theme.palette.text.primary, 0.08),
                mb: 1.2,
              })}
            />
            <Box
              sx={(theme) => ({
                ...shimmer,
                height: 14,
                width: '35%',
                borderRadius: 999,
                bgcolor: alpha(theme.palette.text.primary, 0.06),
                mb: 1.6,
              })}
            />
            <Box
              sx={(theme) => ({
                ...shimmer,
                height: 12,
                width: '80%',
                borderRadius: 999,
                bgcolor: alpha(theme.palette.text.primary, 0.06),
                mb: 2,
              })}
            />
            <Box
              sx={(theme) => ({
                ...shimmer,
                height: 6,
                width: '100%',
                borderRadius: 999,
                bgcolor: alpha(theme.palette.text.primary, 0.08),
              })}
            />
          </Box>
        </Box>
      ))}
    </Stack>
  );
}
